import { useState, useEffect } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('add-cookie-consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('add-cookie-consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('add-cookie-consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: 'var(--blue)', color: '#fff',
      padding: '14px 24px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '16px', flexWrap: 'wrap',
      fontSize: '14px', lineHeight: 1.5,
      boxShadow: '0 2px 12px rgba(0,0,0,.15)',
    }}>
      <p style={{ margin: 0, maxWidth: 700 }}>
        {t.cookie.message}{' '}
        <Link to="/cookies" style={{ color: 'var(--amber)', textDecoration: 'underline' }}>
          {t.cookie.privacyLink}
        </Link>
      </p>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button onClick={handleReject} style={{
          background: 'transparent', border: '1px solid rgba(255,255,255,.5)',
          color: '#fff', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer',
          fontSize: '13px', fontWeight: 600,
        }}>
          {t.cookie.rejectAll}
        </button>
        <button onClick={handleAccept} style={{
          background: 'var(--amber)', border: 'none',
          color: 'var(--blue)', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer',
          fontSize: '13px', fontWeight: 700,
        }}>
          {t.cookie.acceptAll}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
